import $ from 'jquery'
/*
 * Discovers all elements on the page that have been flagged to have a responsive bg size. Uses the 
 *  data-bg-img-lg and data-bg-img-sm data attributes to load correct size, and 
 *  bg-img-lg-position and bg-img-sm-position to position small image
*/
function loadResponsiveBackgrounds() {
  jQuery("*[data-bg-img-lg]").each(function () {
    var me = jQuery(this);
    var bgImg = "";
    if (getIsLarge()) { bgImg = me.data("bg-img-lg"); }
    if (getIsMedium()) { bgImg = me.data("bg-img-md"); }
    if (getIsSmall()) { bgImg = me.data("bg-img-sm"); }

    var bgPos = "";
    if (getIsLarge()) { bgPos = me.data("bg-img-lg-position"); }
    if (getIsMedium()) { bgPos = me.data("bg-img-md-position"); }
    if (getIsSmall()) { bgPos = me.data("bg-img-sm-position"); }
    bgPos = (typeof bgPos === "undefined") ? "center center" : bgPos;

    var bgSize = "";
    if (getIsLarge()) { bgSize = me.data("bg-img-lg-size"); }
    if (getIsMedium()) { bgSize = me.data("bg-img-md-size"); }
    if (getIsSmall()) { bgSize = me.data("bg-img-sm-size"); }
    bgSize = (typeof bgSize === "undefined") ? "cover" : bgSize;

    if (bgImg != "") {
      me.css({
        "background-image": ("url(" + bgImg + ")"),
        "background-position": bgPos,
        "background-size": bgSize
      });
    }

    jQuery("#heroHolder").fadeOut('fast');
  });
}
function accordion(){
  var allPanels = $('.accordion > dd').hide(),
    allPanelLabels = $('.accordion > dt');
  
  $('.accordion > dt .acc-tog').click(function() {
    if ( !$(this).closest('dt').hasClass('active js-open') ) {
      //allPanels.slideUp();
      //allPanelLabels.removeClass('active js-open');
      $(this).closest('dt').next().slideDown();
      $(this).closest('dt').addClass('active js-open');
    }
    else {
      $(this).closest('dt').removeClass('active js-open').next().slideUp();
    }
    return false;
  });
}
loadResponsiveBackgrounds();
function loadOrResize(){
  sizeFormBG();
  threeSlider();  
  heroImage();
  accordion();
  articleSlider();
}
jQuery(window).load(function () {
  jQuery("*[data-load-type]").lazyLoad();
  loadOrResize();
  backgroundImages();
  $("#search_button").click(function() {
    $("#search_lightbox").removeClass('hidden');
    jQuery(jQuery(jQuery('#_search')[0]).children("label")[0]).children()[0].focus();
  });

  $("#search_shadow, #search.wrapper .close").click(function() {
    $("#search_lightbox").addClass('hidden');
  });
  var width = $(window).width();
  if( width > 1150 ){
    $(".img-block-wrap.parallax").parallaxBG({ adjustY: .3, bgXPosition: 'center' });
  }

});
window.addEventListener('resize', function(event){
  loadOrResize();
});
function backgroundImages(){
  $.each( $('.bg-image').not('.business'), function(i, bgImage){
    var src = $(bgImage).data('bg-image');
    $(bgImage).css("background-image", "url(" + src + ")");
  })
}
function heroImage(){
  var video = $('.hero-block-wrapper .bg-vid source').data('lazy-video');
  if( $('.hero-block-wrapper .bg-vid').length == 1 ) {
    $('.hero-block-wrapper .bg-vid source').attr('src',video);
    $('.hero-block-wrapper .bg-vid')[0].load();
    $('.hero-block-wrapper .bg-vid')[0].play();
  }
}

function threeSlider(){
  var width = $(window).width();
  $.each( $('.slider-block-wrapper').not('.article-slider'), function(k,parent){
    var v = $(parent).find('.slide-wrapper'),
      slidesToShow = $(v).data('slides-to-show'),
      wrapperWidth = $(v).width(),
      centerMode = false,
      variableWidth = false,
      arrows = true,
      appendArrows = $(parent).find('.slide-nav');
    var newHeight = 320;      
    if( width < 769 ){
      slidesToShow = 1;
      $(v).data('slides-to-show',1);
      centerMode = true;
      variableWidth = true;
      var cardWidth = width - 40;
    }
    else{
      var cardWidth = ( (wrapperWidth / slidesToShow) - 15),
        arrows = true,
        appendArrows = $(parent).find('.slide-nav');      
      if( 1 == slidesToShow){
        var newHeight = 640;
      }
    }
    $(v).slick({
      centerMode: centerMode,
      variableWidth: variableWidth,
      slidesToShow: slidesToShow,
      arrows:arrows,
      appendArrows: appendArrows
    });

    $(v).find('.shadow-card').width( cardWidth );
    //$(v).height(newHeight);
    $(v).find('.bg-image').height(newHeight);
  });
  //$('.row.slick-slider').css('padding-left',footerPos.left);
  $.each( $('.slider-block-wrapper'), function(k,v){
    var rowHeight = 0;
    $.each( $(v).find('.card-foot-content'), function(a,b){
      var contentHeight = $(b).outerHeight();
      if(contentHeight > rowHeight){
        rowHeight = contentHeight;
      }
    })
    //$(v).find('.card-foot-content').height(rowHeight);
  });
  const swiper = new Swiper('.swiper-container', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
    }
  });
}

function articleSlider(){
  var width = $(window).width();
  $.each( $('.swiper-slide'), function(k,v){
    if( width < 1149 ){
      var cardwidth = width - 200;
      // $(v).closest('.swiper-wrapper').width( cardwidth );
      //      $(v).find('img').width( cardwidth );
    }
    else{
      //    $(v).find('img').attr( 'width','100%' );
      console.log( $(v).width());
    }
  });
}

function sizeFormBG() {
  var formImg = jQuery('.footer-container .form-wrapper');
  if (1==1) {
    getBackgroundImageSize(jQuery('.footer-container .form-wrapper'))
      .then(function(size) {
        var coeff = 0.9;
        //var windowWidth = 1;//jQuery(window).width();
        var newHeight = coeff * size.height;
        var newWidth = coeff * size.width;
        jQuery('.footer-container .form-wrapper').height(newHeight).width(newWidth);
      })
      .fail(function() {
        var pageHero = jQuery('.branson_hero video');
        if(  pageHero.length ){
          var windowWidth = jQuery(window).width();
          var newHeight = ( pageHero.innerHeight() / pageHero.innerWidth() ) * windowWidth;               
          jQuery('.branson_hero').height(newHeight);
        }
        else{
          //console.log('Could not get size because could not load image');
        }
      });
  }
}
function getBackgroundImageSize(el) {    
  var imageUrl = jQuery(el).css('background-image').match(/^url\(["']?(.+?)["']?\)$/);
  var dfd = new jQuery.Deferred();
  if (imageUrl) {
    var image = new Image();
    image.onload = dfd.resolve;
    image.onerror = dfd.reject;
    image.src = imageUrl[1];
  } else {
    dfd.reject();
  }
  return dfd.then(function() {
    return { width: this.width, height: this.height };
  });
}
jQuery(window).load(function () {

  $('.back-to-top').on('click',function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  })
  var videoHeight = $('.hero-block-wrapper video').height();
  if( 0 < videoHeight ){
    $('.hero-block-wrapper .img-block-wrap').height( videoHeight );
  }
  let myHamburger = document.getElementById('hamburger'),
    myNavMenu = document.getElementById('mobileMenu'),
    closeNavMenu = document.getElementById('closeNavMenu'),
    main = document.querySelector('main'),
    myMenuLinks = document.querySelectorAll('nav button, nav a'),
    transitionTime = 400, // This matches what's in the CSS for the transition
    overlay = document.createElement('div');

  document.body.appendChild(overlay);

  function doMenuOpen () {
    myHamburger.setAttribute('aria-expanded', true);
    myNavMenu.classList.remove('vh');
    myNavMenu.classList.remove('hidden');
    main.classList.add('menuOpen');
    myHamburger.classList.add('menuOpen');
    myHamburger.classList.add('hamburger-z');
    window.setTimeout(function () {
      closeNavMenu.focus();
      overlay.classList.add('overlay');
      overlay.addEventListener('click', function () {
        doMenuClose();
      }, false);

      document.addEventListener('keyup', function (e) {
        // 27 = ESC key
        if (e.keyCode === 27) {
          doMenuClose();
        }
      }, false);
    }, transitionTime);
  }

  function doMenuClose () {
    myHamburger.setAttribute('aria-expanded', false);
    myNavMenu.classList.add('hidden');
    main.classList.remove('menuOpen');
    myHamburger.classList.remove('menuOpen');
    overlay.classList.remove('overlay');
    window.setTimeout(function () {
      myNavMenu.classList.add('vh');
      myHamburger.focus();
      overlay.classList.remove('overlay');
      myHamburger.classList.remove('hamburger-z');
    }, transitionTime);
  }

  myHamburger.addEventListener('click', function () {
    if (myNavMenu.classList.contains('hidden')) {
      doMenuOpen();
    } else {
      doMenuClose();
    }
  }, false);

  closeNavMenu.addEventListener('click', function () {
    doMenuClose();
  }, {passive: true});
})
!function(a){"use strict";a.fn.parallaxBG=function(b){var c=a(window).height(),d=0,e=a(window).scrollTop(),f=0,g=0,h=a.extend({adjustX:0,adjustY:0,bgXOffset:0,bgYOffset:0,bgXPosition:"100%",bgYPosition:"100%"},b);return this.each(function(){var b=a(this);a(window).scroll(function(){var i=h.bgXAdjust,j=b.css("backgroundPosition").split(" ");parseInt(j[0]);if(e=a(window).scrollTop(),f=b.offset().top,g=b.outerHeight(),e<d&&0!=i&&(i*=-1),d=e,!(f+g<=e||f>=e+c)){var l=0==h.adjustX?h.bgXPosition:Math.round((f-e)*h.adjustX)+0+h.bgXOffset+"px",m=0==h.adjustY?h.bgYPosition:Math.round((f-e)*h.adjustY)+0+h.bgYOffset+"px";b.css("background-position",l+" "+m)}})})},a.fn.parallaxLockElement=function(b){var c=!1,d=a.extend({parentEl:"",offsetTop:0,additionalCSS:void 0,onLock:void 0,onRelease:void 0},b);return this.each(function(){var b=a(this),e=a(d.parentEl);a(window).scroll(function(){var f=parseInt(e.offset().top-a(window).scrollTop()-d.offsetTop),g=e.offset().top+e.outerHeight(),i=(parseInt(b.outerHeight()),e.offset().top+e.outerHeight()-(b.offset().top+b.outerHeight()));f<=0?g+i<=a(window).scrollTop()+a(window).innerHeight()?c&&(c=!1,b.css({position:"absolute",top:"inherit",bottom:i+"px"}),"function"==typeof d.onRelease&&d.onRelease(this)):(b.css({position:"fixed",top:d.offsetTop+"px",bottom:"auto"}),"function"==typeof d.onLock&&d.onLock(this),c=!0):(b.css({position:"relative",top:"auto"}),"function"==typeof d.onRelease&&d.onRelease(this),c=!1),void 0!=d.additionalCSS&&b.css(d.additionalCSS)})})},a.fn.parallaxAnimateElement=function(b){var c=new Array,d=0,e=0,f=!1,g=a.extend({frames:1,elementClass:"floatingElement",elementFrameClassRoot:"frame",startOffset:null,endOffset:null,showWhenCentered:!1,centerOffsetAnimationRange:null,lock:!1,parentEl:"",offsetTop:0,additionalCSS:void 0,onLock:void 0,onRelease:void 0},b);g.lock?a(this).parallaxLockElement({parentEl:g.parentEl,offsetTop:g.offsetTop,additionalCSS:g.additionalCSS,onLock:g.onLock,onRelease:g.onRelease}):f=!0;var h=parseInt(a(this).parent().height());if(g.showWhenCentered)null==g.centerOffsetAnimationRange?g.centerOffsetAnimationRange=1:g.centerOffsetAnimationRange.indexOf("%")!=-1?g.centerOffsetAnimationRange=parseInt(g.centerOffsetAnimationRange)/100:g.centerOffsetAnimationRange=1;else{if(null!=g.startOffset)if(g.startOffset.indexOf("%")!=-1){var i=parseInt(g.startOffset)/100;d=Math.floor(h*i)}else{var i=parseInt(g.startOffset);d=i}if(null!=g.endOffset)if(g.endOffset.indexOf("%")!=-1){var i=parseInt(g.endOffset)/100;e=Math.floor(h-h*i)}else{var i=parseInt(g.endOffset);e=i}0==d&&0==e||(h=h-e-d);for(var j=h/g.frames,k=1;k<=g.frames;k++)c.push(Math.floor(d+j*k));f&&void 0!=g.additionalCSS&&a(this).css(g.additionalCSS)}return this.each(function(){var b=a(this),d=c.length,e=g.showWhenCentered?a(this).height()*g.centerOffsetAnimationRange:a(this).height();a(window).scroll(function(){var f=b.offset().top,h=!(f+b.outerHeight()<=a(window).scrollTop()||f>=a(window).scrollTop()+a(window).height());if(h){if(g.showWhenCentered){var i=parseInt(b.offset().top-a(window).scrollTop()),j=parseInt(i+e/2),k=parseInt(a(window).innerHeight()/2),l=parseInt(j-e),m=parseInt(j+e);if(k<l)d=1;else if(k>=l&&k<=m){var n=Math.max(0,Math.min(1,1-(l+(j-k))/j));d=Math.ceil(g.frames*n)}else d=g.frames}else for(var o=parseInt(b.parent().offset().top-a(window).scrollTop()),p=o*-1+e/2,q=0;q<c.length;q++)if(p<=c[q]){d=q+1;break}b.attr("class",g.elementClass+" "+g.elementFrameClassRoot+d)}})})}}(jQuery);